import React from 'react';
import Browser from 'giro-react-toolkit/source/UtilityFunctions/Browser';
import PropTypes from 'prop-types';
import GeoLocation from 'GeoLocation';

import "./MapActionBar.scss"

/**
 * Action bar for the map
 * @param props
 */
function MapActionBar(props) {
   const className = Browser.isAndroid() || Browser.isIos() ? "map-action-bar" : "map-action-bar map-action-bar--desktop";

   return (
      <div className={className}>
         <GeoLocation className="map-button" onSuccess={props.onGeoLocationSuccess}/>
         <button className="map-button info-button" type='button' onClick={() => props.showOnBoarding() }>
         </button>
      </div>
   );
}

MapActionBar.propTypes = {
   /**
    * function to call when the onboarding button is pressed
    */
   showOnBoarding: PropTypes.func,
   /**
    * function to call when the geoLocalization button is pressed
    */
   onGeoLocationSuccess: PropTypes.func
}

export default MapActionBar;
